 // [[domain, ...vpath], path, appId]
export type MapInfo = [[string, ...string[]], string, string?, boolean?];

export interface update {
	/**
	 * 更新映射列表，会将原有映射移除
	 * @param data 新的映射列表
	 */
	(data: MapInfo[]): void;
};
export interface set {
	/**
	 * 设置路由映射
	 * @param {String} path   真实路径
	 * @param {String} appId  所属应用Id
	 * @param {String} vpath  映射路径
	 * @param {String} domain 映射域名
	 */
	(path?: string, appId?: string, vpath?: string, domain?: string): void;
}
export interface remove {
	/**
	 * 移除路径
	 * @param {String} path   真实路径
	 * @param {String} appId  所属应用Id
	 * @param {String} vpath  映射路径
	 * @param {String} domain 映射域名
	 */
	(path?: string, appId?: string, vpath?: string, domain?: string): void;
}
export interface find {
	/**
	 * 根据Id搜索映射
	 * @param {String}  path     真实路径
	 * @param {String}  appId    所属应用Id
	 * @param {Boolean} first    是否匹配到一项后立即返回
	 * @return {Array}			 找到的映射
	 */
	(path: string, appId?: string, first?: boolean): [string, string] | null;
}
export interface list {
	/** 获取全部映射的原始数据 */
	(): IterableIterator<MapInfo>;
	/**
	 * 根据Id搜索映射
	 * @param {String}  path     真实路径
	 * @param {String}  appId    所属应用Id
	 * @return {Array}			 找到的映射
	 */
	(path: string | true, appId?: string): IterableIterator<[string, string]>;
}



export let base: MapInfo[] = [];

/**
 * 更新映射列表，会将原有映射移除
 * @param data 新的映射列表
 */
export function update(this: void | MapInfo[], data: MapInfo[]): void {
	if (!Array.isArray(data)) {
		return ;
	}
	const maps = this || base;
	maps.splice(0);
	data.forEach(item => {
		if(!Array.isArray(item)) {
			return;
		}
		try {
			let [[domain, ...vpath], path, appId, main] = item;
			if(typeof path !== 'string') {
				return ;
			}
			if(typeof domain !== 'string') {
				domain = '';
			}
			if(typeof appId !== 'string') {
				appId = '';
			}
			if(typeof main !== 'boolean') {
				main = false;
			}
			vpath = vpath.filter(v => v && typeof v === 'string');
			maps.push([[domain, ...vpath], path, appId]);
		} catch(e) {
			return;
		}
	})
}
/**
 * 设置路由映射
 * @param {String} path   真实路径
 * @param {String} appId  所属应用Id
 * @param {String} vpath  映射路径
 * @param {String} domain 映射域名
 */
export function set(this: void | MapInfo[], path: string, appId?: string, vpath?: string, domain?: string): void {
	const maps = this || base;
	const vpaths = (vpath || '').split('/');
	if (typeof appId !== 'string') {
		appId = '';
	}
	if (!vpaths[0]) {
		vpaths.shift();
	}
	maps.push([[domain || '', ...vpaths], path, appId]);
}

/**
 * 移除路径
 * @param {String} path   真实路径
 * @param {String} appId  所属应用Id
 * @param {String} vpath  映射路径
 * @param {String} domain 映射域名
 */
export function remove(this: void | MapInfo[], path?: string, appId: string = '', vpath: string = '', domain: string = ''): void {
	const maps = this || base;
	if (typeof appId !== 'string') {
		appId = '';
	}
	if (path === undefined) {
		for (let i = maps.length - 1; i >= 0; i--) {
			if (maps[i][2] === appId) {
				maps.splice(i, 1);
			}
		}
	} else {
		if (vpath.length && vpath[0] !== '/') {
			vpath = domain + '/' + vpath;
		} else {
			vpath = domain + vpath;
		}
		for (let i = maps.length - 1; i >= 0; i--) {
			let [tvpath, tpath, tappId] = maps[i];
			if (path === tpath && appId === tappId && tvpath.join('/') === vpath) {
				maps.splice(i, 1);
			}
		}
	}
}

/**
 * 根据Id搜索映射
 * @param {String}  path     真实路径
 * @param {String}  appId    所属应用Id
 * @param {Boolean} first    是否匹配到一项后立即返回
 * @return {Array}			 找到的映射
 */
export function find(this: void | MapInfo[], path: string, appId: string, first?: boolean): [string, string] | null;
export function find(this: void | MapInfo[], path: string, appId: string | boolean, first: boolean | string = false): [string, string] | null {
	const maps = this || base;
	if (typeof appId === 'boolean') {
		[appId, first] = [first, appId];
	}
	if (typeof appId !== 'string') {
		appId = typeof first === 'string' ? first : '';
	}
	try {
		if (first) {
			for (let [vpath, tpath, tappId, main] of maps) {
				if (path === tpath && appId === tappId) {
						const [domain, ...vp] = vpath;
						return ['/' + vp.join('/'), domain];
				}
			}
			return null;
		}
		let ret: [string, ...string[]] | null = null;
		for (let [vpath, tpath, tappId, main] of maps) {
			if (path === tpath && appId === tappId) {
				if (first) {
					const [domain, ...vp] = vpath;
					return ['/' + vp.join('/'), domain];
				}
				if (main) {
					ret = vpath;
					break;
				}
				ret = ret || vpath;
			}
		}
		if (!ret) { return null; }
		const [domain, ...vpath] = ret;
		return ['/' + vpath.join('/'), domain];
	}catch(e) {}
	return null;
}
/**
 * 获取全部映射的原始数据
 */
export function list(this: void | MapInfo[]): IterableIterator<MapInfo>;
/**
 * 根据Id搜索映射
 * @param {String}  path     真实路径
 * @param {String}  appId    所属应用Id
 * @return {Array}			 找到的映射
 */
export function list(this: void | MapInfo[], path: string | true, appId?: string): IterableIterator<[string, string]>;
export function* list(this: void | MapInfo[], path?: string | true, appId?: string): IterableIterator<MapInfo | [string, string]> {
	const maps = this || base;
	if (path === undefined) {
		yield*maps;
	}
	if (path === true) {
		for (let [vpath, tpath, tappId, main] of maps) {
			const [domain, ...path] = vpath;
			yield ['/' + vpath.join('/'), domain];
		}
	}
	if (typeof appId !== 'string') {
		appId = '';
	}
	for (let [vpath, tpath, tappId, main] of maps) {
		if (path === tpath && appId === tappId) {
			const [domain, ...path] = vpath;
			yield ['/' + vpath.join('/'), domain];
		}
	}
}


interface MapApi {
	/** 更新映射列表，会将原有映射移除 */
	update: update,
	/** 设置路由映射 */
	set: set,
	/** 移除路径 */
	remove: remove,
	/** 根据Id搜索映射 */
	find: find,
	/** 获取全部映射的原始数据，或者根据Id搜索映射 */
	list: list,
};
function MapApi(maps: MapInfo[] = []): MapApi {
	return {
		set: set.bind(maps),
		remove: remove.bind(maps),
		find: find.bind(maps),
		list: list.bind(maps),
		update: update.bind(maps),
	}
}
export type api = MapApi;
export default MapApi;
